import React from 'react';
import './TransferOwnershipModal.css';

function TransferOwnershipModal({ isOpen, memberName, onConfirm, onCancel }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="transfer-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>⚠️ Transfert de propriété</h2>
                    <button className="modal-close" onClick={onCancel}>×</button>
                </div>

                <div className="transfer-warning">
                    <div className="warning-icon">🔐</div>
                    <h3>Attention : Cette action est irréversible !</h3>

                    <div className="warning-content">
                        <p>Vous êtes sur le point de transférer la propriété de l'organisation à :</p>
                        <div className="target-member">{memberName}</div>

                        <div className="consequences">
                            <h4>Conséquences :</h4>
                            <ul>
                                <li>✓ <strong>{memberName}</strong> deviendra le nouveau propriétaire</li>
                                <li>⚠️ <strong>Vous</strong> serez automatiquement rétrogradé(e) au rôle d'<strong>Administrateur</strong></li>
                                <li>⚠️ Seul le nouveau propriétaire pourra transférer à nouveau la propriété</li>
                                <li>⚠️ Vous ne pourrez plus supprimer l'organisation sans être à nouveau propriétaire</li>
                            </ul>
                        </div>

                        <p className="confirmation-text">
                            Êtes-vous absolument sûr(e) de vouloir continuer ?
                        </p>
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn-secondary"
                        onClick={onCancel}
                    >
                        Annuler
                    </button>
                    <button
                        type="button"
                        className="btn-danger"
                        onClick={onConfirm}
                    >
                        Oui, transférer la propriété
                    </button>
                </div>
            </div>
        </div>
    );
}

export default TransferOwnershipModal;
